export type InvoiceLocalisationCode = "IN" | "AE";

export type InvoiceLocalisation = {
  code: InvoiceLocalisationCode;
  brokerCountry: string;
  currencySymbol: string;
  numberLocale: string;
  taxLabel: "GST" | "VAT";
  taxRatePercent: number;
  hasStateSplit: boolean;
  taxIdLabel: string;
};

const LOCALISATIONS: Record<InvoiceLocalisationCode, InvoiceLocalisation> = {
  IN: {
    code: "IN",
    brokerCountry: "India",
    currencySymbol: "₹",
    numberLocale: "en-IN",
    taxLabel: "GST",
    taxRatePercent: 18,
    hasStateSplit: true,
    taxIdLabel: "GSTIN",
  },
  AE: {
    code: "AE",
    brokerCountry: "United Arab Emirates",
    currencySymbol: "$",
    numberLocale: "en-AE",
    taxLabel: "VAT",
    taxRatePercent: 5,
    hasStateSplit: false,
    taxIdLabel: "TRN",
  },
};

const DEFAULT_LOCALISATION_CODE: InvoiceLocalisationCode = "IN";

const CODE_BY_ENV_VALUE: Record<string, InvoiceLocalisationCode> = {
  IN: "IN",
  IND: "IN",
  INDIA: "IN",
  AE: "AE",
  UAE: "AE",
  "UNITED ARAB EMIRATES": "AE",
};

function resolveLocalisation(): InvoiceLocalisation {
  const rawValue = import.meta.env.VITE_APP_LOCALISATION_COUNTRY?.trim().toUpperCase();
  const code = CODE_BY_ENV_VALUE[rawValue || ""] || DEFAULT_LOCALISATION_CODE;

  return LOCALISATIONS[code];
}

export const INVOICE_LOCALISATION = resolveLocalisation();
